import z from 'zod'
import { decimalSchema } from '../../utils/schema'
import { createSodexObjectEnvelopeSchema } from '../sodexEnvelopeSchema'

const spotBalanceRowSchema = z.object({
  id: z.number(),
  coin: z.string(),
  total: decimalSchema,
  locked: decimalSchema,
})

const sodexSpotAccountBalancesDataSchema = z.object({
  blockTime: z.number().default(0),
  blockHeight: z.number().default(0),
  balances: z.array(spotBalanceRowSchema).default([]),
})

const perpsBalanceRowSchema = z.object({
  id: z.number(),
  coin: z.string(),
  total: decimalSchema,
  marginRatio: decimalSchema,
  price: z.union([decimalSchema, z.null()]).optional(),
})

const sodexPerpsAccountBalancesDataSchema = z.object({
  blockTime: z.number().default(0),
  blockHeight: z.number().default(0),
  balances: z.array(perpsBalanceRowSchema).default([]),
})

/** 現物口座残高 API（`/accounts/{userAddress}/balances`）のレスポンス用スキーマ */
export const spotBalancesResponseSchema = createSodexObjectEnvelopeSchema(
  sodexSpotAccountBalancesDataSchema,
)

/** 先物口座残高 API（`/accounts/{userAddress}/balances`）のレスポンス用スキーマ */
export const perpsBalancesResponseSchema = createSodexObjectEnvelopeSchema(
  sodexPerpsAccountBalancesDataSchema,
)
